import Swiper, {Navigation} from 'swiper';

$(document).on('ready', function(){
    var swiper = new Swiper(".section-products-carousel__swiper", {
        slidesPerView: 1.3,
        spaceBetween: 25,
        slidesOffsetBefore: 36,
        slidesOffsetAfter: 36,
        modules:[ Navigation ],
        breakpoints: {
            1024: {
                slidesPerView: 1,
                spaceBetween: 0,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                navigation: {
                    prevEl: '.section-products-carousel__button-prev',
                    nextEl: '.section-products-carousel__button-next'
                }
            }
        }

    })

    $('.section-products-carousel__button-prev, .section-products-carousel__button-next').on('click', () => {
        swiper.slideToClosest();
    })
})
